const { hostname } = window.location

const config = {
  // Opción 1 (B): API por same-origin (IIS reverse proxy /api -> backend)
  // Si no se define env, por defecto usa "/"
  apiURL: process.env.REACT_APP_API_URL || '/',

  // Identity normalmente es un host aparte; lo dejamos por env.
  // (No ponemos localhost como fallback para no romper en producción)
  identityServerApiURL: process.env.REACT_APP_IDENTITY_SERVER
    ? `${process.env.REACT_APP_IDENTITY_SERVER}`.replace(/\/?$/, '/')
    : '',

  IdentityClientID: hostname,
}

export { config as default }
